import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { BUSINESS } from "@/config";

export const FloatingButtons = () => {
  const waText = encodeURIComponent("Hi! I'd like to check tire availability.");
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={`https://wa.me/${BUSINESS.whatsapp}?text=${waText}`}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-2 bg-[#25D366] text-black font-bold pl-4 pr-4 py-3 rounded-full shadow-lg shadow-black/40 hover:scale-105 transition-transform"
        data-testid="whatsapp-fab"
        aria-label="Chat on WhatsApp"
      >
        <WhatsappLogo size={26} weight="fill" />
        <span className="hidden sm:inline text-sm uppercase tracking-wide">WhatsApp</span>
      </a>
      <a
        href={`tel:${BUSINESS.phoneRaw}`}
        className="group flex items-center gap-2 bg-primary text-white font-bold pl-4 pr-4 py-3 rounded-full shadow-lg shadow-black/40 hover:scale-105 transition-transform"
        data-testid="call-fab"
        aria-label="Call us"
      >
        <Phone size={26} weight="fill" />
        <span className="hidden sm:inline text-sm uppercase tracking-wide">Call</span>
      </a>
    </div>
  );
};
